import React from 'react';
import { styled } from '@compiled/react';
import TickIcon from '@atlaskit/icon/glyph/editor/done';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { singleLineClamp } from '@atlassian/jira-common-styles/src/mixins';
import { useIntl } from '@atlassian/jira-intl';
import type { EpicOption } from '../../../common/types';

import messages from './messages';

export const renderOptionDescription = (option: EpicOption, doneEpicLabel: string) => (
	<OptionDescriptionWrapper>
		{option.description != null ? <Description>{option.description}</Description> : null}
		{option.isDone === true ? (
			<>
				<TickIcon
					primaryColor={token('color.text.success', colors.G500)}
					label="include-done-epics"
				/>
				<span>{doneEpicLabel}</span>
			</>
		) : null}
	</OptionDescriptionWrapper>
);

const CustomOption = ({ option }: { option: EpicOption }) => {
	const { formatMessage } = useIntl();

	return (
		<OptionWrapper>
			{option.elemBefore != null ? option.elemBefore : null}
			<OptionTextContainer>
				<OptionLabel>{option.label}</OptionLabel>
				{renderOptionDescription(option, formatMessage(messages.doneEpicLabel))}
			</OptionTextContainer>
		</OptionWrapper>
	);
};

export default CustomOption;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionDescriptionWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest', colors.N300),
	fontSize: '12px',
	marginTop: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.span({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionWrapper = styled.span({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionTextContainer = styled.span({
	display: 'flex',
	flexDirection: 'column',
	margin: `0 ${token('space.100', '8px')}`,
	padding: `${token('space.025', '2px')} 0`,
	overflow: 'hidden',
	flexGrow: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const OptionLabel = styled.span(singleLineClamp, {
	flexGrow: 1,
});
